import { useQueryParams } from 'module/helpers/location-query-params';
import { logger } from 'module/logger';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { useOktaAuth } from '@okta/okta-react';
import { FC, useEffect, useState } from 'react';

export const LoginWithSessionToken: FC = () => {
  const { oktaAuth } = useOktaAuth();
  const params = useQueryParams();
  const sessionToken = params.get('token');

  const [isSessionLoading, setIsSessionLoading] = useState(false);

  useEffect(() => {
    if (sessionToken) {
      setIsSessionLoading(true);
      oktaAuth.token
        .getWithRedirect({ sessionToken, prompt: 'none' })
        .catch((error) => {
          logger.error('token setup failed', { error });
          setIsSessionLoading(false);
        });
    }
  }, [oktaAuth, sessionToken]);

  if (isSessionLoading) {
    return <PageLoading />;
  }

  return null;
};
